import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/data/www/musikum_portal/prod/.app/layouts/default.vue").then(m => m.default || m)),
  "validate-data": defineAsyncComponent(() => import("/data/www/musikum_portal/prod/.app/layouts/validate-data.vue").then(m => m.default || m)),
  collapse: defineAsyncComponent(() => import("/data/www/musikum_portal/prod/layers/tairo-layout-collapse/layouts/collapse.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/data/www/musikum_portal/prod/layers/tairo/layouts/empty.vue").then(m => m.default || m))
}